import { toast as sonnerToast } from "sonner"

export { Toaster } from "./toaster"

type ToastContent = string | { message: string; description: string }

export const toast = {
	success: (message: string) => {
		sonnerToast.success(message)
	},

	error: (message: string) => {
		sonnerToast.error(message)
	},

	promise: <T>(
		promise: Promise<T>,
		messages: {
			loading: string
			success: ToastContent | ((data: T) => ToastContent)
			error: string | ((error: unknown) => string)
		},
	) => {
		const { success } = messages
		return sonnerToast.promise(promise, {
			...messages,
			success: (data: T) => {
				const content = typeof success === "function" ? success(data) : success
				return typeof content === "string" ? { message: content } : content
			},
		})
	},
}
